<template>
  <v-row no-gutters class="mb-2">
    <v-col cols="4" class="item-day">
      <v-row no-gutters align="center">
        <v-col cols="6">
          <span>{{ day.name }}</span>
        </v-col>
        <v-col cols="6" class="d-flex align-center my-2">
          <v-switch
            class="ml-4 mt-0 pb-1"
            color="primary"
            v-model="isOpen"
            hide-details
            @change="handleSwitch($event)"
            inset
          ></v-switch>
          <span>
            {{
              isOpen ? $t("message.common.open") : $t("message.common.closed")
            }}
          </span>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="5" class="item-hours">
      <template v-if="isOpen">
        <HoursPanel
          v-for="(hours, index) in formattedHours"
          :key="`hours-${day.name}${index}`"
          :hours="hours"
          :hoursRange="hoursRange"
          :hasButton="index > 0"
          @remove="handleRemove(index)"
          @hours="updateHours(index, $event)"
        />
      </template>
    </v-col>
    <v-col cols="3" class="item-actions">
      <ui-button color="secondary" @click="handleClick" :disabled="!isOpen">
        {{ $t("message.facilityDetails.addWorkingHours") }}
      </ui-button>
    </v-col>
  </v-row>
</template>

<script>
import HoursPanel from "@/components/FacilityDetails/Dialog/shared/ItemHoursPanel.vue";

export default {
  name: "OpenHoursItem",
  components: {
    HoursPanel
  },
  props: {
    day: {
      type: Object,
      default: () => {
        return {
          name: ""
        };
      }
    },
    hoursRange: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: this.day.value.length > 0,
      formattedHours: this.day.value
    };
  },
  methods: {
    handleClick() {
      this.formattedHours.push(["", ""]);
      this.$emit("trigger");
    },
    handleRemove(index) {
      this.formattedHours.splice(index, 1);
      this.$emit("trigger");
    },
    handleSwitch(changedVal) {
      if (!changedVal) {
        this.formattedHours.splice(0, this.formattedHours.length);
      }

      if (changedVal && !this.formattedHours.length > 0) {
        this.formattedHours.push(["", ""]);
      }

      this.$emit("trigger");
    },
    updateHours(index, { from, to }) {
      this.formattedHours[index] = [from, to];
      this.$emit("trigger");
    }
  }
};
</script>

<style lang="scss" scoped>
.item-day,
.item-hours,
.item-actions {
  display: flex;
  align-items: flex-start;
}

.item-actions {
  margin-top: 12px;
  justify-content: center;
}

.item-hours {
  flex-direction: column;
  margin-top: 12px;
}

.item-day {
  padding-right: 60px;
}
</style>
